import BaseAPI from './BaseAPI';
import ServiceApiUrlsStore from '../stores/ServiceApiUrlsStore';

class CredAPIWrapper {
  constructor(api) {
    this.api = api;
  }

  // Resource CRUD
  getResources() {
    return this.api.get('/api/v2/resources')
      .then(data => data.body);
  }

  postResource(resource) {
    const payload = { resource };

    return this.api.post('/api/v2/resources', payload)
      .then(data => data.body);
  }

  getResource(resourceId) {
    return this.api.get(`/api/v2/resources/${resourceId}`)
      .then(data => data.body);
  }

  updateResource(resourceId, resource) {
    const payload = { resource };

    return this.api.put(`/api/v2/resources/${resourceId}`, payload)
      .then(data => data.body);
  }

  deleteResource(resourceId) {
    return this.api.del(`/api/v2/resources/${resourceId}`)
      .then(data => data.body);
  }


  // Secret CRUD
  getSecrets() {
    return this.api.get('/api/v2/secrets')
      .then(data => data.body);
  }

  postSecret(secret) {
    const payload = { secret };

    return this.api.post('/api/v2/secrets', payload)
      .then(data => data.body);
  }

  getSecret(secretId) {
    return this.api.get(`/api/v2/secrets/${secretId}`)
      .then(data => data.body);
  }

  updateSecret(secretId, secret) {
    const payload = { secret };

    return this.api.put(`/api/v2/secrets/${secretId}`, payload)
      .then(data => data.body);
  }

  deleteSecret(secretId) {
    return this.api.del(`/api/v2/secrets/${secretId}`)
      .then(data => data.body);
  }
}

class CredAPI extends BaseAPI {
  constructor(token) {
    super(ServiceApiUrlsStore.getCredServiceUrl(), token);
    this.creds = new CredAPIWrapper(this);
  }
}

export default CredAPI;
